export default __webpack_public_path__ + "static/media/gbp.c14d3d19.png";